export const list = {
  root: [
    {
      구분: "사업단장",
      성명: "유재수",
      연락처: ["043-261-3230", "010-9722-2922"],
      "e-mail": "yjs@cbnu.ac.kr",
      담당업무: "사업단 총괄 관리",
    },
  ],
  전략기획부단장: [
    {
      구분: "전략기획부단장",
      성명: "이정환",
      연락처: ["043-261-2342", "010-6860-8019"],
      "e-mail": "junghwan@cbnu.ac.kr",
      담당업무: "사업단 총괄 운영(기획재정 및 인력양성)",
    },
  ],
  실행운영부단장: [
    {
      구분: "실행운영부단장",
      성명: "조중상",
      연락처: ["043-2461-2489", "010-2649-5966"],
      "e-mail": "JSCHO@cbnu.ac.kr",
      담당업무: "사업단 총괄 운영(대외협력 및 산학협력)",
    },
  ],
  "strategic-planning": [
    {
      구분: "부장",
      성명: "박민정",
      연락처: ["043-249-1561", "010-4857-2228"],
      "e-mail": "mjp80@cbnu.ac.kr",
      담당업무: "사업단 행정 총괄",
    },
    {
      구분: "부장",
      성명: "이재문",
      연락처: ["043-261-3792"],
      "e-mail": "jmlee1105@cbnu.ac.kr",
      담당업무: "사업제반 기획, 사업비 관리  ․ 각종 위원회 운영",
    },
    {
      구분: "실장",
      성명: "신경운",
      연락처: ["043-249-1276", "010-5030-5116"],
      "e-mail": "sandigi@cbnu.ac.kr",
      담당업무: "사업단 행정 업무 총괄, 사업단 회계업무 총괄",
    },
    {
      구분: "팀장",
      성명: "김현정",
      연락처: ["043-249-1800", "010-5040-0904"],
      "e-mail": "hj5040@cbnu.ac.kr",
      담당업무: "사업단 행정 업무 총괄",
    },
    {
      구분: "팀장",
      성명: "박나리",
      연락처: ["043-261-3645", "010-4222-0607"],
      "e-mail": "pnr85@cbnu.ac.kr",
      담당업무: "전략기획관리 업무",
    },
    {
      구분: "팀원",
      성명: "강동호",
      연락처: ["043-249-1277", "010-5650-5116"],
      "e-mail": "hokang8@cbnu.ac.kr",
      담당업무: "회계 업무 집행 및 관리",
    },
    {
      구분: "팀원",
      성명: "하현지",
      연락처: ["043-261-3647", "010-9541-0315"],
      "e-mail": "guswl0315@cbnu.ac.kr",
      담당업무:
          "사업단 성과 관리, 사업단 인프라 및 홍보, 성과교류회, 취업박람회, 전시회, 경진대회 등 관리",
    },
    {
      구분: "팀원",
      성명: "유성복",
      연락처: ["043-261-3230"],
      "e-mail": "sbyoo90@cbnu.ac.kr",
      담당업무: "대응자금, 간접비 관련 업무, 단장 업무 보조",
    },
  ],
  "future-talent": [
    {
      구분: "부장",
      성명: "연성호",
      연락처: ["043-249-1764", "010-8840-5853"],
      "e-mail": "shy316@cbnu.ac.kr",
      담당업무: "산학친화형 교육과정 및 프로그램 운영",
    },
    {
      구분: "산학협력중점교수",
      성명: "유범선",
      연락처: ["043-261-3328", "010-5650-4457"],
      "e-mail": "bsryu@cbnu.ac.kr",
      담당업무:
          "취업패키지, 대학원 산학연계 교육과정, 기업맞춤형 트랙, 지역고교 프로그램, 표준현장실습",
    },
    {
      구분: "산학협력중점교수",
      성명: "송영준",
      연락처: ["043-249-1889", "010-4052-3196"],
      "e-mail": "songyjorg@cbnu.ac.kr",
      담당업무: "이차전지 핵심인재 양성, 시군특화형 AI모빌리티",
    },
    {
      구분: "산학협력중점교수",
      성명: "정보 없음",
      연락처: ["043-249-1327"],
      "e-mail": "neoshaky@cbnu.ac.kr",
      담당업무: "클러스터(순환경제, 오송철도), 사이버보안 시군특화 사업",
    },
    {
      구분: "1팀장",
      성명: "전찬우",
      연락처: ["043-249-1792"],
      "e-mail": "cksn95@cbnu.ac.kr",
      담당업무:
          "표준현장실습․ 지역고교생 프로그램 모니터링, 3대전략 핵심인재양성센터 모니터링 ",
    },
    {
      구분: "팀원",
      성명: "노희주",
      연락처: ["043-249-1831"],
      "e-mail": "rohhj@cbnu.ac.kr",
      담당업무: "반도체 핵심인재양성센터 운영",
    },
    {
      구분: "팀원",
      성명: "배수빈",
      연락처: ["043-249-1802"],
      "e-mail": "sb7@cbnu.ac.kr",
      담당업무: "바이오 핵심인재양성센터 운영",
    },
    {
      구분: "팀원",
      성명: "박성근",
      연락처: ["043-261-3529"],
      "e-mail": "825252@cbnu.ac.kr",
      담당업무: "이차전지 핵심인재양성센터 운영  ․ 프리칼리지",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1335"],
      "e-mail": "jsa@cbnu.ac.kr",
      담당업무: "기업맞춤형트랙, 캡스톤디자인교과목, 취업패키지",
    },
    {
      구분: "2팀장",
      성명: "송재인",
      연락처: ["043-261-3659"],
      "e-mail": "jisong@cbnu.ac.kr",
      담당업무: "오송철도 클러스터형 교육과정 프로그램",
    },
    {
      구분: "팀원",
      성명: "신지은",
      연락처: ["043-261-3646"],
      "e-mail": "sje@cbnu.ac.kr",
      담당업무: "첨단농업, 사이버보안, 바이오-AI 시군특화형",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1337"],
      "e-mail": "yoonji0223@cbnu.ac.kr",
      담당업무: "순환경제 클러스터형 교육과정 프로그램, 충주·증평형 풀뿌리",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1338"],
      "e-mail": "825454@cbnu.ac.kr",
      담당업무: "보건의료 혁신 클러스터형 교육과정 프로그램, 전문간호인력 평생교육 활성화 프로그램",
    },
    {
      구분: "팀원",
      성명: "서희승",
      연락처: ["043-249-1855"],
      "e-mail": "heeseung@cbnu.ac.kr",
      담당업무:
          "성인학습자(재직자) 교육 과정 개발운영 지원 및 실적 관리, AI모빌리티 시군특화형",
    },
    {
      구분: "팀원",
      성명: "김동호",
      연락처: ["010-6246-2390"],
      "e-mail": "dh3034@cbnu.ac.kr",
      담당업무: "첨단농업 시군특화, 농업플랜트 기자재 관리",
    },
  ],
  "industry-academia": [
    {
      구분: "부장",
      성명: "김연우",
      연락처: ["043-249-1782", "010-3643-6658"],
      "e-mail": "ywk@cbnu.ac.kr",
      담당업무: "기술개발, 기술지도, 기술이전 및 산학협력 프로그램 운영",
    },
    {
      구분: "산학협력중점교수",
      성명: "정보 없음",
      연락처: ["043-249-1766"],
      "e-mail": "hyokjo@cbnu.ac.kr",
      담당업무: "산학공동기술개발과제",
    },
    {
      구분: "산학협력중점교수",
      성명: "우동석",
      연락처: ["043-261-3663"],
      "e-mail": "dswoo@cbnu.ac.kr",
      담당업무: "애로기술지도, 공용장비활용교육",
    },
    {
      구분: "산학협력중점교수",
      성명: "송영준",
      연락처: ["043-249-1889"],
      "e-mail": "songyjorg@cbnu.ac.kr",
      담당업무: "창업지원센터",
    },
    {
      구분: "팀장",
      성명: "이수한",
      연락처: ["043-249-1278", "010-7760-2817"],
      "e-mail": "lsh9444@cbnu.ac.kr",
      담당업무: "이차전지 공동연구센터, AX기업혁신센터 운영, 산학공동기술개발과제, 시제품제작지원사업, 특화프로그램",
    },
    {
      구분: "팀원",
      성명: "유영란",
      연락처: ["043-249-1282", "010-2537-4610"],
      "e-mail": "educom@cbnu.ac.kr",
      담당업무: "첨단바이오 공동연구센터, 첨단로봇 공동연구센터, 산학공동기술개발과제",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1285", ""],
      "e-mail": "inni93@cbnu.ac.kr",
      담당업무: "반도체 공동연구센터, AI‧모빌리티 공동연구센터, 산학공동기술개발과제, 애로기술지도, 공용장비활용교육",
    },

    {
      구분: "팀원",
      성명: "전지윤",
      연락처: ["043-249-1281", "010-9285-8958"],
      "e-mail": "jeonjy@cbnu.ac.kr",
      담당업무:
          "K-유학생 지원 및 AI 플랫폼 구축",
    },

    {
      구분: "팀원",
      성명: "서보민",
      연락처: ["043-249-1284", "010-4043-4167"],
      "e-mail": "sbm41@cbnu.ac.kr",
      담당업무: "창업 동아리 운영 및 성과 확산, 창업관련 프로그램 운영",
    },
    {
      구분: "팀원",
      성명: "김현지",
      연락처: ["043-249-1280", "010-5671-8855"],
      "e-mail": "kkkhj1213@cbnu.ac.kr",
      담당업무: "시제품 제작 지원",
    },
  ],
  "core-battery": [
    {
      구분: "센터장",
      성명: "신종호",
      연락처: ["043-261-2447"],
      "e-mail": "moonhee@cbnu.ac.kr",
      담당업무: "인재양성 이차전지 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "박성근",
      연락처: ["043-261-3529"],
      "e-mail": "825252@cbnu.ac.kr",
      담당업무: "이차전지 핵심인재양성센터 운영  ․ 프리칼리지",
    },
  ],
  "core-semiconductor": [
    {
      구분: "센터장",
      성명: "강문희",
      연락처: ["043-261-3138"],
      "e-mail": "moonhee@cbnu.ac.kr",
      담당업무: "인재양성 반도체 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "노희주",
      연락처: ["043-249-1831"],
      "e-mail": "rohhj@cbnu.ac.kr",
      담당업무: "반도체 핵심인재양성센터 운영",
    },
  ],
  "core-bio": [
    {
      구분: "센터장",
      성명: "성현아",
      연락처: ["043-261-2308"],
      "e-mail": "haseung@cbnu.ac.kr",
      담당업무: "인재양성 바이오 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "배수빈",
      연락처: ["043-249-1802"],
      "e-mail": "sb7@cbnu.ac.kr",
      담당업무: "바이오 핵심인재양성센터 운영",
    },
  ],
  "regional-ai": [//AI모빌리티
    {
      구분: "센터장",
      성명: "기석철",
      연락처: ["043-261-1683"],
      "e-mail": "sckee@cbnu.ac.kr",
      담당업무: "시군특화형 AI모빌리티 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "이름없음",
      연락처: ["043-249-1855"],
      "e-mail": "inni93@cbnu.ac.kr",
      담당업무:
          "성인학습자(재직자) 교육 과정 개발운영 지원 및 실적 관리, AI모빌리티 시군특화형",
    },
  ],
  "regional-agri": [//첨단농업 (Agri-Life)
    {
      구분: "센터장",
      성명: "최성호",
      연락처: ["043-261-2545"],
      "e-mail": "seongho@cbnu.ac.kr",
      담당업무: "시군특화형 Agri-Life 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "신지은",
      연락처: ["043-261-3646"],
      "e-mail": "sje@cbnu.ac.kr",
      담당업무: "첨단농업, 사이버보안, 바이오-AI 시군특화형",
    },
  ],
  "regional-cyber": [
    {
      구분: "센터장",
      성명: "김태성",
      연락처: ["043-261-3343"],
      "e-mail": "kimts@cbnu.ac.kr",
      담당업무: "시군특화형 사이버보안 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "신지은",
      연락처: ["043-261-3646"],
      "e-mail": "sje@cbnu.ac.kr",
      담당업무: "첨단농업, 사이버보안, 바이오-AI 시군특화형",
    },
  ],
  "regional-bioai": [
    {
      구분: "센터장",
      성명: "서제훈",
      연락처: ["043-261-2866"],
      "e-mail": "seojh@cbnu.ac.kr",
      담당업무: "시군특화형 바이오-AI 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "신지은",
      연락처: ["043-261-3646"],
      "e-mail": "sje@cbnu.ac.kr",
      담당업무: "첨단농업, 사이버보안, 바이오-AI 시군특화형",
    },
  ],
  "regional-choongju": [
    {
      구분: "센터장",
      성명: "기석철",
      연락처: ["043-261-1683"],
      "e-mail": "sckee@cbnu.ac.kr",
      담당업무: "시군특화형 충주형, 증평형 풀뿌리 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1337"],
      "e-mail": "yoonji0223@cbnu.ac.kr",
      담당업무: "순환경제 클러스터형 교육과정 프로그램, 충주·증평형 풀뿌리",
    },
  ],
  "cluster-osong": [
    {
      구분: "센터장",
      성명: "윤재중",
      연락처: ["043-261-2474"],
      "e-mail": "jjyun@cbnu.ac.kr",
      담당업무: "클러스터 오송철도 업무 총괄",
    },
    {
      구분: "2팀장",
      성명: "송재인",
      연락처: ["043-261-3659"],
      "e-mail": "jisong@cbnu.ac.kr",
      담당업무: "오송철도 클러스터형 교육과정 프로그램",
    },
  ],
  "cluster-circular": [
    {
      구분: "센터장",
      성명: "반영운",
      연락처: ["043-261-3391"],
      "e-mail": "byubyu@cbnu.ac.kr",
      담당업무: "클러스터 순환경제 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1337"],
      "e-mail": "yoonji0223@cbnu.ac.kr",
      담당업무: "순환경제 클러스터형 교육과정 프로그램, 충주·증평형 풀뿌리",
    },
  ],
  "joint-bio": [
    {
      구분: "센터장",
      성명: "손동주",
      연락처: ["043-261-2822"],
      "e-mail": "sondj1@cbnu.ac.kr",
      담당업무: "공동연구센터 첨단바이오 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1282"],
      "e-mail": "educom@cbnu.ac.kr",
      담당업무: "첨단바이오 공동연구센터, 첨단로봇 공동연구센터,산학공동기술개발과제",
    },
  ],
  "joint-battery": [
    {
      구분: "센터장",
      성명: "조중상",
      연락처: ["043-261-2489"],
      "e-mail": "JSCHO@cbnu.ac.kr",
      담당업무: "공동연구센터 전고체전지 업무 총괄",
    },
    {
      구분: "팀장",
      성명: "정보 없음",
      연락처: ["043-249-1278"],
      "e-mail": "lsh9444@cbnu.ac.kr",
      담당업무: "이차전지 공동연구센터, AX기업혁신센터 운영, 산학공동기술개발과제   ,시제품제작지원사업, 특화프로그램",
    },
  ],
  "joint-semiconductor": [
    {
      구분: "센터장",
      성명: "이상진",
      연락처: ["043-261-3134"],
      "e-mail": "leesj@cbnu.ac.kr",
      담당업무: "공동연구센터 시스템반도체 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1285"],
      "e-mail": "inni93@cbnu.ac.kr",
      담당업무: "반도체 공동연구센터, AI‧모빌리티 공동연구센터, 산학공동기술개발과제, 애로기술지도, 공용장비활용교육",
    },
  ],
  "joint-ai": [
    {
      구분: "센터장",
      성명: "기석철",
      연락처: ["043-249-1683"],
      "e-mail": "sckee@cbnu.ac.kr",
      담당업무: "공동연구센터 AI 모빌리티 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1285"],
      "e-mail": "inni93@cbnu.ac.kr",
      담당업무: "반도체 공동연구센터, AI‧모빌리티 공동연구센터, 산학공동기술개발과제, 애로기술지도, 공용장비활용교육",
    },
  ],
  "joint-robot": [
    {
      구분: "센터장",
      성명: "황영배",
      연락처: ["043-261-3641"],
      "e-mail": "ybhwang@cbnu.ac.kr",
      담당업무: "공동연구센터 첨단로봇 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1282"],
      "e-mail": "educom@cbnu.ac.kr",
      담당업무: "첨단바이오 공동연구센터, 첨단로봇 공동연구센터,산학공동기술개발과제",
    },
  ],
  startup: [
    {
      구분: "센터장",
      성명: "정보 없음",
      연락처: ["043-249-1889"],
      "e-mail": "songyjorg@cbnu.ac.kr",
      담당업무: "창업지원센터 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1284"],
      "e-mail": "sbm41@cbnu.ac.kr",
      담당업무:
          "창업 동아리 운영 및 성과 확산, 창업관련 프로그램 운영",
    },
  ],
  lifelong: [
    {
      구분: "센터장",
      성명: "정보 없음",
      연락처: ["043-261-3952"],
      "e-mail": "summi@cbnu.ac.kr",
      담당업무: "에이스 브릿지 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1855"],
      "e-mail": "heeseung@cbnu.ac.kr",
      담당업무: "성인학습자(재직자) 교육 과정 개발·운영 지원 및 실적 관리, AI모빌리티 시군특화형",
    },
  ],
  "k-student": [
    {
      구분: "센터장",
      성명: "정보 없음",
      연락처: ["043-261-2358"],
      "e-mail": "cgkim@cbnu.ac.kr",
      담당업무: "K-유학생 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1281"],
      "e-mail": "jeonjy@cbnu.ac.kr",
      담당업무: "K-유학생 지원 및 AI 플랫폼 구축",
    },
  ],
  "living-research": [
    {
      구분: "센터장",
      성명: "김미경",
      연락처: ["043-261-3616"],
      "e-mail": "mkmkkim@cbnu.ac.kr",
      담당업무: "생활연구소 업무 총괄",
    },
    {
      구분: "연구원",
      성명: "이성연",
      연락처: ["010-6788-6030"],
      "e-mail": "syyi@cbnu.ac.kr",
      담당업무: "생활연구소 프로그램 운영",
    },
  ],
  neulbom: [
    {
      구분: "센터장",
      성명: "손동주",
      연락처: ["043-261-2822"],
      "e-mail": "sondj1@cbnu.ac.kr",
      담당업무: "공동연구센터 첨단바이오 업무 총괄",
    },
    {
      구분: "연구원",
      성명: "정보 없음",
      연락처: ["043-261-3262"],
      "e-mail": "cbscitech@chungbuk.ac.kr",
      담당업무: "늘봄 프로그램 운영 개발, 강사 관리",
    },
    {
      구분: "연구원",
      성명: "조아람",
      연락처: ["043-261-3262"],
      "e-mail": "cast3483@cbnu.ac.kr",
      담당업무: "늘봄 프로그램 운영 개발, 강사 관리",
    },
  ],
  "cluster-healthcare": [
    {
      구분: "센터장",
      성명: "정보 없음",
      연락처: ["043-261-2873"],
      "e-mail": "jonghyock@cbnu.ac.kr",
      담당업무: "클러스터 보건의료 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1338"],
      "e-mail": "825454@cbnu.ac.kr",
      담당업무: "보건의료 혁신 클러스터형 교육과정 프로그램, 전문간호인력 평생교육 활성화 프로그램",
    },
  ],
  "joint-axcenter": [
    {
      구분: "센터장",
      성명: "정보 없음",
      연락처: ["043-249-1621"],
      "e-mail": "ysjay@cbnu.ac.kr",
      담당업무: "공동연구센터 AX센터 업무 총괄",
    },
    {
      구분: "팀장",
      성명: "정보 없음",
      연락처: ["043-249-1278"],
      "e-mail": "lsh9444@cbnu.ac.kr",
      담당업무: "이차전지 공동연구센터, AX기업혁신센터 운영, 산학공동기술개발과제   ,시제품제작지원사업, 특화프로그램",
    },
  ],
  "lifelong-healthcare": [
    {
      구분: "센터장",
      성명: "정보 없음",
      연락처: ["043-249-1860"],
      "e-mail": "cgkim@cbnu.ac.kr",
      담당업무: "전문간호인력 평생교육 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1338"],
      "e-mail": "825454@cbnu.ac.kr",
      담당업무: "보건의료 혁신 클러스터형 교육과정 프로그램, 전문간호인력 평생교육 활성화 프로그램",
    },
  ],
  "k-student-startup": [
    {
      구분: "센터장",
      성명: "정보 없음",
      연락처: ["043-261-3202"],
      "e-mail": "ykkim153@cbnu.ac.kr",
      담당업무: "기술창업 K-유학생 업무 총괄",
    },
    {
      구분: "팀원",
      성명: "정보 없음",
      연락처: ["043-249-1159"],
      "e-mail": "cbyy12@cbnu.ac.kr",
      담당업무: "충북형 K-유학생 유치 및 정주 지원(석·박사 과정)",
    },
  ],
  synchrotron: [
    {
      구분: "센터장",
      성명: "정보 없음",
      연락처: ["043-261-2268"],
      "e-mail": "donghyun@cbnu.ac.kr",
      담당업무: "방사광 가속기 기반 연구 업무 총괄",
    },
    {
      구분: "연구원",
      성명: "정보 없음",
      연락처: ["043-249-1640"],
      "e-mail": "sh5050@cbnu.ac.kr",
      담당업무: "RISE 방사광가속기 센터 업무 담당",
    },
  ],
  "shared-university": [
    {
      구분: "학장",
      성명: "이재권",
      연락처: ["043-261-2734", "010-3021-6901"],
      "e-mail": "chemokine@cbnu.ac.kr",
      담당업무: "충북 PRIDE 공유대학 업무 총괄",
    },
  ],
  "shared-governance": [
    {
      구분: "팀장",
      성명: "김정아",
      연락처: ["043-249-1263", "010-6616-6009"],
      "e-mail": "jatt2@cbnu.ac.kr",
      담당업무: "충북 PRIDE 공유대학 운영 총괄",
    },
    {
      구분: "팀원",
      성명: "신혜수",
      연락처: ["043-249-1267", "010-6636-8428"],
      "e-mail": "hyesu523@cbnu.ac.kr",
      담당업무:
          "공동교육과정 개발, 개편 및 산학 교과과정 개발, 공유대학 예산 관리 및 위원회 운영",
    },
    {
      구분: "팀원",
      성명: "최수미",
      연락처: ["043-249-1264", "010-4294-0497"],
      "e-mail": "sumi2013@cbnu.ac.kr",
      담당업무:
          "충북 PRIDE 공유대학 글로벌 과정 운영, 학생모집 선발 홍보 및 학생선발시스템 운영",
    },
    {
      구분: "팀원",
      성명: "박희진",
      연락처: ["043-249-1266", "010-3036-7566"],
      "e-mail": "glwldl11@cbnu.ac.kr",
      담당업무: "공유대학 학생모집 선발 및 학생선발시스템 운영, 공유대학 핵심역량 진단조사 및 운영, 충북 PRIDE 공유대학 단과대학 업무",
    },
    {
      구분: "팀원",
      성명: "김세연",
      연락처: ["043-249-1265", "010-6349-9504"],
      "e-mail": "seyeon@cbnu.ac.kr",
      담당업무: "공유대학 실무역량 인증제 기획·운영, 공유대학 공동교육과정 만족도 조사, 학제 간 편입학 유연화 추진",
    },
  ],
  "shared-academic": [
    {
      구분: "팀장",
      성명: "김아름",
      연락처: ["043-249-1272", "010-5751-9027"],
      "e-mail": "areum4444@cbnu.ac.kr",
      담당업무: "충북 PRIDE 공유대학 학사관리 총괄",
    },
    {
      구분: "팀원",
      성명: "송선영",
      연락처: ["043-249-1273", "010-9667-4714"],
      "e-mail": "rsun14@cbnu.ac.kr",
      담당업무:
          "공동교육과정 정규학기 운영 및 수업관리, 학생 이수관리 및 교.강사 강의 평가, 학생정보시스템(SIS)운영",
    },
    {
      구분: "팀원",
      성명: "유은진",
      연락처: ["043-249-1275", "010-3482-2279"],
      "e-mail": "eunjin3482@cbnu.ac.kr",
      담당업무:
          "공동교육과정 계절학기 운영 및 수업관리, 공유대학 홈페이지 운영, 충북 PRIDE 공유대학 단과대 행정업무",
    },
    {
      구분: "팀원",
      성명: "이혜인",
      연락처: ["043-249-1274", "010-3356-9003"],
      "e-mail": "lhi1021@cbnu.ac.kr",
      담당업무: "공유대학 학습관리시스템(LMS) 운영, 비교과프로그램 운영, 공유대학 강사료 및 공동교육과정 이수지원금 지출",
    },
  ],
  "shared-enterprise": [
    {
      구분: "팀장",
      성명: "곽다나",
      연락처: ["043-249-1268", "010-5483-8634"],
      "e-mail": "dana216@cbnu.ac.kr",
      담당업무: "충북 PRIDE 공유대학 취업 및 성과관리 총괄",
    },
    {
      구분: "팀원",
      성명: "홍다은",
      연락처: ["043-249-1271", "010-9493-8674"],
      "e-mail": "cong@cbnu.ac.kr",
      담당업무: "산학 교과과정 및 취업지원 운영, 공유대학 표준현장실습 운영 지원, 공유대학 산학협력 성과관리 및 환류",
    },
    {
      구분: "팀원",
      성명: "고주연",
      연락처: ["043-249-1269", "010-4968-4054"],
      "e-mail": "kjybin00@cbnu.ac.kr",
      담당업무: "공유대학 산학 관련 예산 관리, 공유대학 참여기업 관리, 충북 PRIDE 공유대학 단과대학 업무",
    },
    {
      구분: "팀원",
      성명: "박용",
      연락처: ["043-249-1270", "010-4802-3601"],
      "e-mail": "py0810@cbnu.ac.kr",
      담당업무: "공유대학 서포터즈 운영, 공유대학 현장실습 및 취업 관련 기업조사, 공유대학 성과 홍보 및 확산",
    },
  ],
};
